/** @jsxImportSource @emotion/react */
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { accessAPI, storeInLS, urlLogin } from "../../shared";
import { Skeleton } from "primereact/skeleton";

export default function Login() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Intenta obtener el oauthtoken del state (navegación interna) o de la URL (llegada directa)
    const oauthtoken = state?.oauthtoken || searchParams.get("oauthtoken");

    if (oauthtoken) {
      accessAPI(
        "POST",
        "oauth/onetimesignon",
        { oauthtoken },
        (response) => {
          storeInLS(process.env.REACT_APP_LS_LOGIN_TOKEN, response.token);
          navigate("/");
        },
        (response) => {
          window.location.href = urlLogin();
        }
      );
    } else {
      window.location.href = urlLogin();
    }
  }, [state, navigate, searchParams]);

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: "1rem",
      }}
    >
      <Skeleton shape="circle" size="4rem" />
      <Skeleton width="12rem" height="1.5rem" />
      <Skeleton width="8rem" height="1rem" />
    </div>
  );
}
